import React, { useState } from 'react';
import './contact.css';
import TopNavbar from '../../components/Nav/TopNavbar';
import Footer from '../../components/Sections/Footer/Footer';
import Candidate from '../../assets/WhatWeDo/Candidate.png';
import Business from '../../assets/WhatWeDo/Business.png';

export default function ContactUsForm() {

    const [formType, setFormType] = useState('business');

    const toggleForm = (type) => {
        setFormType(type);
    };

    return (
        <>
           <TopNavbar />
            <div className="py-5 py-lg-5" style={{ backgroundImage: formType == 'candidate' ? `url(${Candidate})` : `url(${Business})`, backgroundColor: "#D5D0EF" }} >

                <div className="toggle-box">
                    <div className="toggle-buttons">
                        <button
                            className={`toggle-button ${formType === 'candidate' ? 'active' : ''} `}
                            onClick={() => toggleForm('candidate')}
                        >
                            Candidate
                        </button>
                        <button
                            className={`toggle-button ${formType === 'business' ? 'active' : ''}`}
                            onClick={() => toggleForm('business')}
                        >
                            Business
                        </button>
                    </div>
                </div>
                 {formType === 'candidate' ? <>
                <h1 style ={{ color:'#160A54'}}>Looking for new career opportunities?</h1>
                <h6 style ={{ color:'#160A54'}}>We’re here to guide you every step of the way.</h6></> : <>
                <h1 style ={{ color:'#160A54'}}>Interested in our HR services?</h1>
                <h6 style ={{ color:'#160A54'}}>Let’s talk about how we can meet your business’s unique needs.</h6></> }
                <div className="row">
                <div className='col-3'></div>

                <div className='col-6' id="form-container">

                    {formType === 'candidate' && (
                        <div className="candidate-form">
                            <div className="form-group">
                                <input type="text" className="form-input" placeholder="Name" required />
                                <input type="text" className="form-input" placeholder="Country" required />
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-input" placeholder="Phone" required />
                                <input type="text" className="form-input" placeholder="City" required />
                            </div>
                            <div className="form-group full-width">
                                <input type="email" className="form-input full-width" placeholder="Email I'd" required />
                            </div>
                            <div className="form-group full-width">
                                <textarea className="form-textarea full-width" placeholder="Career Brief..." required></textarea>
                            </div>
                            <div className="form-group center">
                                <button className="upload-button">Upload Your CV</button>
                            </div>
                            <div className="form-group center">
                                <button className="submit-button">Submit</button>
                            </div>
                        </div>
                    )}


                    {formType === 'business' && (
                        <div className="business-form">
                            <div className="form-group">
                                <input type="text" className="form-input" placeholder="Business Name" required />
                                <input type="text" className="form-input" placeholder="Industry" required />
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-input" placeholder="Contact Person" required />
                                <input type="text" className="form-input" placeholder="Phone" required />
                            </div>
                            <div className="form-group full-width">
                                <input type="email" className="form-input full-width" placeholder="Business Email" required />
                            </div>
                            <div className="form-group full-width">
                                <textarea className="form-textarea full-width" placeholder="Project Details" required></textarea>
                            </div>
                            <div className="form-group center">
                                <button className="submit-button">Submit</button>
                            </div>
                        </div>
                    )}
                </div>
                <div className='col-3'></div>
                </div>
            </div>
            <Footer />
        </>
    );

}

